module.exports = __webpack_public_path__ + "img/icon_jpy.46c8e49c.svg";